import { Box } from "@mui/material";
import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useAppStore } from "../../../../../hooks/useStores";
import styles from "./VideoRemoveBackgroundConfig.module.scss";

const VideoRemoveBackgroundConfig = () => {
	const { t } = useTranslation("video_editing", { keyPrefix: "lab.config.tools.remove_background.config" });
	const { videoEditingStore } = useAppStore();

	useEffect(() => {
		videoEditingStore.handleConfigChange("tool_config", {
			...videoEditingStore.config.tool_config,
			remove_background: true,
		});

		return () => {
			delete videoEditingStore.config.tool_config?.remove_background;
		};
	}, []);

	return (
		<Box className={styles.container}>
			<Box className={styles.description}>{t("description")}</Box>
		</Box>
	);
};

export default observer(VideoRemoveBackgroundConfig);
